function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fafafa;}.cls-2{fill:url(#radial-gradient);}.cls-3{fill:url(#radial-gradient-2);}.cls-4{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient",
  cx: -82.31,
  cy: -122.96,
  r: 1.57,
  gradientTransform: "matrix(1.13, 0, 0, -0.86, 98.24, -94.1)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ef8886",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.15,
  stopColor: "#f0908e",
  stopOpacity: 0.43
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.38,
  stopColor: "#f3a7a5",
  stopOpacity: 0.31
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#f8cbca",
  stopOpacity: 0.17
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#fffefe",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-2",
  cx: -73.26,
  cy: -122.96,
  r: 1.57,
  xlinkHref: "#radial-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 1.38,
  y1: 19.47,
  x2: 21.8,
  y2: 9.95,
  gradientTransform: "matrix(1, 0, 0, -1, 0, 26)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "avatar");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M21.1,2.92A17.81,17.81,0,0,0,12.32.48,17.73,17.73,0,0,0,3.55,2.92,2.48,2.48,0,0,0,2.32,5.07v8.41c0,3.89,4.52,9.36,9.25,9.92a4.8,4.8,0,0,0,.31.8.49.49,0,0,0,.44.28.5.5,0,0,0,.45-.28,5.47,5.47,0,0,0,.31-.8c4.73-.56,9.24-6,9.24-9.92V5.07A2.49,2.49,0,0,0,21.1,2.92Z",
  transform: "translate(-2.32 -0.48)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M21.32,13.38c0,3.34-3.94,8.17-8,8.89a2.55,2.55,0,0,0,0-.39,4.18,4.18,0,0,0-.42-2l.37-.74a.48.48,0,0,0,0-.48.5.5,0,0,0-.43-.24h-1a.49.49,0,0,0-.42.24.48.48,0,0,0,0,.48l.37.74a4.12,4.12,0,0,0-.43,2,2.56,2.56,0,0,0,0,.39c-4.09-.72-8-5.55-8-8.89V5a1.48,1.48,0,0,1,.73-1.28,16.76,16.76,0,0,1,8.27-2.31A16.77,16.77,0,0,1,20.6,3.69,1.49,1.49,0,0,1,21.32,5Z",
  transform: "translate(-2.32 -0.48)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M6.47,9.12a.53.53,0,0,0-.15.36.51.51,0,0,0,.15.35,2.64,2.64,0,0,0,1.85.65,2.65,2.65,0,0,0,1.86-.65.5.5,0,0,0,.14-.35.52.52,0,0,0-.14-.36,2.72,2.72,0,0,0-1.86-.64A2.7,2.7,0,0,0,6.47,9.12Z",
  transform: "translate(-2.32 -0.48)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M14.47,9.12a.53.53,0,0,0-.15.36.51.51,0,0,0,.15.35,2.64,2.64,0,0,0,1.85.65,2.65,2.65,0,0,0,1.86-.65.5.5,0,0,0,.14-.35.52.52,0,0,0-.14-.36,2.72,2.72,0,0,0-1.86-.64A2.7,2.7,0,0,0,14.47,9.12Z",
  transform: "translate(-2.32 -0.48)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M4.59,7.41a.49.49,0,0,0,.67-.2s.44-.73,2.06-.73a4.63,4.63,0,0,1,3.1,1.8.51.51,0,0,0,.4.2.48.48,0,0,0,.3-.11.48.48,0,0,0,.1-.69,5.54,5.54,0,0,0-3.9-2.2c-2.24,0-2.88,1.14-2.94,1.27A.5.5,0,0,0,4.59,7.41Z",
  transform: "translate(-2.32 -0.48)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M13.82,8.48a.48.48,0,0,0,.4-.2s1.38-1.8,3.1-1.8,2,.68,2.06.73a.5.5,0,0,0,.67.21.5.5,0,0,0,.22-.67c-.06-.13-.7-1.27-2.95-1.27s-3.83,2.11-3.9,2.2a.49.49,0,0,0,.1.69A.5.5,0,0,0,13.82,8.48Z",
  transform: "translate(-2.32 -0.48)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M19,10.12a.5.5,0,0,0,0,.7A1.74,1.74,0,0,1,19.32,12a1.35,1.35,0,0,1-1.5,1.5A4.75,4.75,0,0,1,16.05,13a.5.5,0,0,0-.67.22.49.49,0,0,0,.22.67,5.88,5.88,0,0,0,1.92.54l-1,2H14.13L13.41,15a2.37,2.37,0,0,0,.35-.4l.12-.17a.5.5,0,0,0-.06-1,1.11,1.11,0,0,0-.88.58c-.19.28-.3.42-.62.42s-.42-.14-.62-.42a1.08,1.08,0,0,0-.88-.58.53.53,0,0,0-.54.48.45.45,0,0,0,.46.49,1.25,1.25,0,0,1,.15.19,2.79,2.79,0,0,0,.34.4l-.72,1.44H8.13l-1-2a5.89,5.89,0,0,0,1.93-.54.5.5,0,0,0,.22-.67A.5.5,0,0,0,8.6,13a4.76,4.76,0,0,1-1.78.45A1.35,1.35,0,0,1,5.32,12a1.8,1.8,0,0,1,.36-1.16.5.5,0,0,0,0-.7.51.51,0,0,0-.71,0A2.65,2.65,0,0,0,4.32,12,2.31,2.31,0,0,0,6,14.34L7.38,17.2a.49.49,0,0,0,.44.28h3a.5.5,0,0,0,.45-.28l.86-1.72h.38l.87,1.72a.49.49,0,0,0,.44.28h3a.5.5,0,0,0,.45-.28l1.43-2.85A2.32,2.32,0,0,0,20.32,12a2.72,2.72,0,0,0-.64-1.86A.5.5,0,0,0,19,10.12Z",
  transform: "translate(-2.32 -0.48)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M11.82,13a.5.5,0,0,0,.5-.5V10a.5.5,0,0,0-.5-.5.5.5,0,0,0-.5.5v2.5A.51.51,0,0,0,11.82,13Z",
  transform: "translate(-2.32 -0.48)"
});

var _ref12 = /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-2",
  cx: 4.88,
  cy: 11.35,
  rx: 1.78,
  ry: 1.35
});

var _ref13 = /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-3",
  cx: 15.15,
  cy: 11.35,
  rx: 1.78,
  ry: 1.35
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M21.1,2.92A17.81,17.81,0,0,0,12.32.48,17.73,17.73,0,0,0,3.55,2.92,2.48,2.48,0,0,0,2.32,5.07v8.41c0,3.89,4.52,9.36,9.25,9.92a4.8,4.8,0,0,0,.31.8.49.49,0,0,0,.44.28.5.5,0,0,0,.45-.28,5.47,5.47,0,0,0,.31-.8c4.73-.56,9.24-6,9.24-9.92V5.07A2.49,2.49,0,0,0,21.1,2.92Z",
  transform: "translate(-2.32 -0.48)"
});

var SvgAvatar = function SvgAvatar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 20 24",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAvatar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/avatar.24093871.svg";
export { ForwardRef as ReactComponent };